import React, { Component } from 'react';
import { Form, Input, message, Modal, Row } from 'antd';

import { queryCheckContract, queryRefuseContract } from '@api/xxcrm/contract';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = () => {
    const data = this.props.form.getFieldsValue();
    const { record } = this.props;
    data.uuid = record.uuid;
    delete data.price;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.deal === 'agree') {
          this.checkContract(data);
        } else {
          this.refuseContract(data);
        }
      }
    });
  };

  /**
   * 同意使用合同
   */
  checkContract = params => {
    queryCheckContract(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.cancel();
        this.props.loadDate();
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 拒绝使用合同
   */
  refuseContract = params => {
    queryRefuseContract(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.cancel();
        this.props.loadDate();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { cancel, record, deal } = this.props;
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    const titleStr = deal === 'agree' ? '合同使用同意' : '合同使用拒绝';
    return (
      <Modal
        title={titleStr}
        width={400}
        visible
        onCancel={cancel}
        onOk={this.submit}
        maskClosable={false}
      >
        <Form className="modal" layout="inline">
          <Row>
            <FormItem label="合同编号" {...formItemLayout}>
              <p>{record.no}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="合同所属人" {...formItemLayout}>
              <p>{record.belonging}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="订单编号" {...formItemLayout}>
              <p>{record.orderNo}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="客户名称" {...formItemLayout}>
              <p>{record.customName}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="合同金额" {...formItemLayout}>
              {getFieldDecorator('price', {
                rules: [{ required: true, message: '合同金额不能为空！' }],
                initialValue: record.price,
              })(<Input type="number" />)}
            </FormItem>
          </Row>
          <Row>
            <FormItem label="审批备注" {...formItemLayout}>
              {getFieldDecorator('checkRemark', {
                rules: [{ required: true, message: '审批备注不能为空！' }],
              })(<Input />)}
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/ModalAgree.js